import React, { Component } from "react";
import Form from "react-validation/build/form";

import DatePicker from "../../components/DatePicker";
import Input from "../../components/Input";
import TextBox from "../../components/TextBox";
import { required, integerValidator } from "../../validation/validation";
import { ValidationProvider } from "../../validation/validation-provider";
import trashBin from "../../images/icon-trashbin.svg";

class QuoteViewDetailRow extends Component {
  constructor(props) {
    super(props);

    this.formRef = React.createRef();

    this.updateData = this.updateData.bind(this);
  }

  updateData(value) {
    this.props.updateQuoteDetails(this.props.widgetData.WidgetId, value);
  }

  render() {
    const widgetData = this.props.widgetData;

    return (
      <tr className={this.props.rowColor}>
        <td className="lob-details-coverage-description">
          <span
            className={widgetData.WidgetType === "ToggleButton" ? "bold" : ""}
          >
            {widgetData.DisplayLabel}
          </span>
        </td>
        <td>
          <span className="lob-details-coverage-value">
            <Form ref={this.formRef}>
              {this.getWidget(widgetData)}
            </Form>
          </span>
          <div
            className="error-message"
            hidden={widgetData.ValidationMessages.length === 0}
          >
            {widgetData.ValidationMessages[0]}
          </div>
        </td>
      </tr>
    );
  }

  getWidget(widgetData) {
    switch (widgetData.WidgetType) {
      case "DropDown":
        widgetData.AvailableOptions.forEach((element) => {
          element.Name = element.DisplayLabel;
          element.Value = element.Value !== null ? element.Value : "null";
        });
        return (
          <select
            name={widgetData.WidgetId}
            className="coverage-value-dropdown"
            onChange={(e) => {
              if (e.target.value === "null") {
                this.updateData([null]);
              } else {
                this.updateData([e.target.value]);
              }
            }}
            id={widgetData.WidgetId}
            value={widgetData.Value || "null"}
          >
            <option value="" disabled hidden></option>
            {widgetData.AvailableOptions.map((item) => (
              <option key={item.Value} value={item.Value}>
                {item.DisplayLabel}
              </option>
            ))}
          </select>
        );
      case "DatePicker":
        return (
          <DatePicker
            {...widgetData}
            onValueChanged={(value) => this.updateData([value])}
          />
        );
      case "TextBox":
        if (widgetData.DataType === "Money") {
          return (
            <TextBox
              {...widgetData}
              AllowNull={true}
              onChange={(value) => {
                var valid = ValidationProvider.isValid(this.formRef);
                if (valid) {
                  this.updateData([value]);
                }
              }}
              name="name"
              field="name"
            />
          );
        }

        return (
          <Input
            type="text"
            maxLength={widgetData.Validation.MaxLength}
            value={widgetData.Value}
            onBlur={(e) => {
              var valid = ValidationProvider.isValid(this.formRef);
              if (valid) {
                this.updateData([e.target.value]);
              }
            }}
            validations={[required, integerValidator]}
            name="name"
            field="name"
          />
        );
      case "ToggleButton":
        return widgetData.Value === "True" ? (
          <>
            <button
              className="coverage-value-button"
              onClick={(e) => {
                e.preventDefault();
                this.updateData(["False"]);
              }}
            >
              <img src={trashBin} alt="remove" />
            </button>
          </>
        ) : (
          <button
            className="coverage-value-button add-button"
            onClick={(e) => {
              e.preventDefault();
              this.updateData(["True"]);
            }}
          >
            + Add
          </button>
        );
      default:
        return null;
    }
  }
}

export default QuoteViewDetailRow;
